<template>
  <div class="layout">
    <div class="tag">
      <div v-for="(item, index) in tags" :key="index">
        <div class="tag-child" :class="[index !== tags.length ? 'gj-mb10' : '',
        item.id === active ? 'check--color' : 'notCheck--color']" @click="clickTag(item.id)">{{item.text}}</div>
      </div>
    </div>
    <div class="content">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
    export default {
      name: "app-left-tag",
      props: {
        tags: {
          type: Array,
          require: true,
        },
      },
      data() {
        return {
          active:  this.tags[0].id
        }
      },
      methods: {
        clickTag(id) {
          this.active = id;
          this.$emit('clickTag', id);
        }
      }
    }
</script>

<style scoped>
  .layout {
    padding: 10px 20px;
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
  }
  .tag {
    width: 30px;
    height: 100%;
    border-right: 1px solid #e5e5e5;
  }
  .tag-child {
    text-align: center;
    border-radius: 6px 0 0 6px;
    padding: 12px 16px 12px 8px;
    font-size: 14px;
    cursor: pointer;
  }
  .content {
    flex: 1;
    background-color: #ffffff;
    overflow: hidden;
  }
  .tag .check--color {
    background-color: #0045f0;
    color: #fff;
  }
  .tag .notCheck--color {
    background-color: #ffff;
    color: #666;
  }
</style>
